(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.GraphicalComponents;

    (function (GraphicalComponents, $, undefined) {
        /**
         * @memberOf Lfl.GraphicalComponents
         */
         Lfl.GraphicalComponents.Buttons;

        (function (Buttons, $, undefined) {
            if(Lfl.Files.isLoadedAlready(Lfl.GraphicalComponents.Buttons, 'ModalButton')) {
                return;
            }

            /**
             * An object handling the behavior of a modal-opening button.
             *
             * @param parameters
             * @param {string} parameters.buttonId
             * @param {string} parameters.modalBuilderId
             * @param {string | string[]} parameters.actionGroups
             *
             * @memberOf Lfl.GraphicalComponents.Buttons
             * @lends Lfl.GraphicalComponents.Buttons.ModalButton
             */
            Lfl.GraphicalComponents.Buttons.ModalButton = function(parameters) {
                const $button = $('#' + parameters.buttonId);

                /**
                 * Registers this button to be activated when the page is loaded.
                 */
                this.register = function() {
                    FunctionsCaller.register(
                        (function () {
                            $button.click(function (event) {
                                // It is safer to select the modal after the button is clicked because of scenarios when
                                // the button is added to the page dynamically (via AJAX).
                                // The impact on performance is negligible while errors are prevented.
                                var $modal = $('#' + parameters.modalBuilderId);

                                Lfl.Modals.Displayer.displayBootstrapModal($modal);
                            })
                        }),
                        parameters.actionGroups
                    );
                };
            };
        }(GraphicalComponents.Buttons = GraphicalComponents.Buttons || {}, jQuery));
    }(Lfl.GraphicalComponents = Lfl.GraphicalComponents || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
